import React from 'react';
import { useAuth } from '../contexts/AuthContext';
import { Loader2 } from 'lucide-react';

/** Gate for authed routes. Renders a full-screen loader while the AuthContext
 *  finishes hydrating; kicks off signIn() when we're sure the user is not signed in. */
const RequireAuth: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { ready, isAuthenticated, signIn } = useAuth();

  React.useEffect(() => {
    if (ready && !isAuthenticated) signIn();
  }, [ready, isAuthenticated, signIn]);

  if (!ready || !isAuthenticated) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-space-950 text-white/60">
        <Loader2 className="h-6 w-6 animate-spin mr-2" />
        <span className="text-sm">Signing you in…</span>
      </div>
    );
  }
  return <>{children}</>;
};

export default RequireAuth;
